export default "__VITE_ASSET__23513432__"